import React, { useEffect, useState } from "react";
import "./Generate_Report_form.css";
import { Button, Form, Nav, Tab } from "react-bootstrap";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";
import { allRoomType } from "../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { ReportGenerate } from "../../../../../../../features/admin/quality_management/resource_requirement/environmentcondition/Slice";
import { ClipLoader } from "react-spinners";
function Generate_Report_form() {
  const [showModal, setShowModal] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const dispatch = useDispatch();
  const all_room_type = useSelector((state) => state.common.all_room_type);
  useEffect(() => {
    dispatch(allRoomType());
  }, [dispatch]);

  useEffect(() => {
    if (all_room_type.length > 0) {
      setActiveId(all_room_type?.[0]);
    }
  }, [all_room_type]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const handleDownloadInvoice = async (invoicePath) => {
    if (!invoicePath) {
      alert("Invoice not available");
      return;
    }

    try {
      const fileUrl = `${process.env.REACT_APP_IMG_URL}${invoicePath}`;

      // Fetch the file as blob
      const response = await fetch(fileUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();

      // Create a temporary object URL from blob
      const url = window.URL.createObjectURL(blob);
      setLoder(false);
      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Room_Report.pdf`); // you can make this dynamic
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };
  const [loader, setLoder] = useState(false);
  const onSubmit = async (d) => {
    try {
      setLoder(true);
      d.room_type_id = activeId?.value;
     

      const res = await dispatch(ReportGenerate(d));

      if (res.meta?.requestStatus === "fulfilled") {
        handleDownloadInvoice(res?.payload.data);
        // setSuccess(true);
        // setErrorMessage(false);
        // await dispatch(GetAllInstrument({}));
        // setTimeout(() => {
        //   setSuccess(false);
        //   onHide();
        // }, 2000);
      } else {
        // setErrorMessage(res.payload.errors);
        // setTimeout(() => {
        //   setErrorMessage(false);
        //   onHide();
        // }, 2000);
        // setSuccess(true);
      }
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  return (
    <>
      <section className="Legal_Entity_Form Generate_Report_form">
        <div className="white_container customer_section">
          <div className="tables_tab_section">
            <Tab.Container id="left-tabs-example" activeKey={activeId?.value}>
              <Nav variant="pills" className="">
                <div className="note_text_holder">
                  <p className="red_text mb-0">
                    Select Room For Generate Report:
                  </p>
                </div>
                {all_room_type?.map((val, index) => (
                  <Nav.Item onClick={() => setActiveId(val)}>
                    <Nav.Link eventKey={val?.value}>{val?.label}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>

              <Tab.Content className="inner-tab-sec">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Tab.Pane eventKey={activeId?.value}>
                    <Form.Group className="form_group">
                      <Form.Label>Generate Report:</Form.Label>
                    </Form.Group>

                    <div className="row">
                      {/* Lab Room */}
                      <div className="col-md-4">
                        <Form.Group className="form_group ">
                          <Form.Control
                            placeholder="Date From : DD/MM/YYYY"
                            type="date"
                            {...register("start_date", {
                              required: "Start Date is required",
                              // validate: (value) => {
                              //   const year = value.split("-")[0];

                              //   if (year.length !== 4) {
                              //     return "Year must be exactly 4 digits";
                              //   }

                              //   const selectedDate = new Date(value);
                              //   const today = new Date();
                              //   today.setHours(0, 0, 0, 0);

                              //   if (selectedDate < today) {
                              //     return "Past dates are not allowed";
                              //   }

                              //   return true;
                              // },
                            })}
                            onChange={(e) => {
                              let value = e.target.value;
                              const parts = value.split("-");

                              if (parts[0] && parts[0].length > 4) {
                                parts[0] = parts[0].slice(0, 4);
                                e.target.value = parts.join("-");
                              }
                            }}
                          />
                          {errors.start_date && (
                            <Form.Text className="text-danger">
                              {errors.start_date.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-md-4">
                        <Form.Group className="form_group ">
                          <Form.Control
                            placeholder="Date To : DD/MM/YYYY"
                            type="date"
                            {...register("end_date", {
                              required: "End Date is required",
                              // validate: (value) => {
                              //   const year = value.split("-")[0];

                              //   if (year.length !== 4) {
                              //     return "Year must be exactly 4 digits";
                              //   }

                              //   const selectedDate = new Date(value);
                              //   const today = new Date();
                              //   today.setHours(0, 0, 0, 0);

                              //   if (selectedDate < today) {
                              //     return "Past dates are not allowed";
                              //   }

                              //   return true;
                              // },
                            })}
                            onChange={(e) => {
                              let value = e.target.value;
                              const parts = value.split("-");

                              if (parts[0] && parts[0].length > 4) {
                                parts[0] = parts[0].slice(0, 4);
                                e.target.value = parts.join("-");
                              }
                            }}
                          />
                          {errors.end_date && (
                            <Form.Text className="text-danger">
                              {errors.end_date.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                    </div>

                    {loader ? (
                      <>
                        <div className="permission_btn_holder mt-4">
                          <ClipLoader />
                        </div>
                      </>
                    ) : (
                      <div className="permission_btn_holder mt-4">
                        <Button
                          className="permission_btn Yes_btn"
                          type="submit"
                          // onClick={() => setShowModal(true)}
                        >
                          Generate Report
                        </Button>
                      </div>
                    )}
                  </Tab.Pane>
                </Form>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </section>
      <Certification_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        modalHeadingText={"Generate Lab Room Report"}
        imgSrc={"/assets/images/cerificate/certi.png"}
        btnText={"Download"}
      />
    </>
  );
}

export default Generate_Report_form;
